module.exports = "<div class=\"rulesManagement\">\n    <div class=\"rules-container\">\n        <rule-list #nameRef [processData]=\"processData\" [rules]=\"result\" (onAddRule)=\"addRule()\" (onGetRule)=\"getRule($event)\"></rule-list>\n    </div>\n    <rule-item [processData]=\"processData\" [rule]=\"selectedItem\" \n               [rules]=\"rules\" [indexInList]=\"indexInList\"\n               (onSaveRule)=\"onSaveRule()\" (onDelete)=\"onDeleteRule()\" (onCancel)=\"onCancel()\" (onDuplicate)=\"onDuplicateRule()\"\n    ></rule-item>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/policyEngine/rules-management/rules-management.component.html
// module id = 1773
// module chunks = 0